import { createClient } from 'contentful';

const config = (function () {
  let configVars;
  switch (window.location.origin) {
    case 'https://app.fitchconnect-dev.com':
    case 'https://app.fitchconnect-qa.com':
      configVars = {
        environment: 'qa',
        accessToken: '3m9pLeCpbFyTITGhc0SFp9eMv2wlBEtz4EWKCPS74uY',
      };
      break;
    case 'https://app.fitchconnect-stg.com':
      configVars = {
        environment: 'stage',
        accessToken: 'hucO4-izrJ__n1wMdgbj52PYNhbg7BcUe-bbWWRtWOw',
      };
      break;
    default:
      configVars = {
        environment: 'master',
        accessToken: 'B5wul1CFZaQvf4uLuDIJP1CJWLwAySj-a0JWPpY5K3A',
      };
  }
  return configVars;
})();

export const contentfulClient = createClient({
  space: 'e2s0hfbcq4ff',
  host: 'cdn.contentful.com',
  accessToken: config.accessToken,
  environment: config.environment,
});
